module.exports = __webpack_public_path__ + "static/AddPost-9f2747f74d6bf62b3bcd66092eefd12f.png";